import axios from 'axios';

const API = "https://pl-video-server-production.up.railway.app";
//const API = "http://localhost:8181";

const client = axios.create({
    baseURL: API,
    json: true,
});


class Client {

  getGames(date) {
    const path = `/games/${date}`;
    return this.get({ path });
  }

  getGamePitchers(gamePk) {
    const path = `/games/pitchers/${gamePk}`;
    return this.get({ path });
  }

  getPitcherGames(pitcherName) {
    const path = `/pitchers/${pitcherName}`;
    return this.get({ path });
  }
  
  getAllPitchers() {
    const path = `/pitchers`;
    return this.get({ path });
  }

  getGameInfo(gamePk) {
    const path = `/games/info/${gamePk}`;
    return this.get({ path });
  }

    /*** PERFORM ***/
  async get({ data, params, path } = {}) {
    return this.perform('get', path, params, data);
  }

  async post({ data, params, path } = {}) {
    return this.perform('post', path, params, data);
  }

  async put({ data, params, path } = {}) {
    return this.perform('put', path, params, data);
  }

  async delete({ data, params, path } = {}) {
    return this.perform('delete', path, params, data);
  }

  async perform(method, path, params = {}, data) {
    const code = `${method.toUpperCase()} req: ${path}`;
    console.debug(`➡️ ${code} params:`, params, 'data:', data);
    const headers = {
    };

    const resp = await client({
      method,
      url: path,
      params,
      data,
      timeout: 0,
      headers
    })
    .catch(({
      message,
      response: { data: { error } = {}} = {}}
      ) => {
        console.debug(`⛔️ ${code} failed:\n😵`, error, '\n✉️', message);
        throw new Error(error || message)
    });
    const dataResponse = resp.data || [];
    console.debug(`✔ ${code}:`, dataResponse);
    return dataResponse;
  }
}

export default Client;